var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLsCompletedInverted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Checkmark_Inverted",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Border",
    "data-name": "Ellipse 16",
    fill: "#5b788f",
    cx: 14,
    cy: 14,
    r: 14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    "data-name": "Ellipse 11",
    fill: "#fff",
    cx: 14,
    cy: 14,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Checkmark_Left",
    "data-name": "Line 5",
    fill: "#5b788f",
    d: "m12.33,18.62c-.26,0-.51-.1-.69-.29l-3.98-3.97c-.38-.38-.38-1,0-1.38,0,0,0,0,0,0,.38-.38,1-.38,1.38,0,0,0,0,0,0,0l3.97,3.98c.38.38.38,1,0,1.38-.18.18-.43.29-.69.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Checkmark_Right",
    "data-name": "Line 6",
    fill: "#5b788f",
    d: "m12.36,18.62c-.26,0-.51-.1-.69-.29-.38-.38-.38-1,0-1.38l7.29-7.29c.38-.38,1-.38,1.38,0,.38.38.38,1,0,1.38,0,0,0,0,0,0l-7.29,7.29c-.18.18-.43.29-.69.29Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLsCompletedInverted);
export default __webpack_public_path__ + "static/media/icon_ls_completed_inverted.6ee877f3aa5b3720d98379cb053ca548.svg";
export { ForwardRef as ReactComponent };